import React from "react";
import { Container } from "./ErrorModalStyles";

const ErrorModal = ({ handleClose, error = "Unknown Error Occurred" }) => (
  <Container error className={"flex"}>
    <span className="line" />
    <svg width="20px" height="20px">
      <use xlinkHref="#warning" />
    </svg>
    <span className={"text"}>{error}</span>
    <div className="close-btn" onClick={() => handleClose()} />
  </Container>
);

export default ErrorModal;
